module.exports = __webpack_public_path__ + "img/20200114160409915.9208244f.jpg";